import type { RouteRecordRaw } from "vue-router";

const canvasModulesRoutes: RouteRecordRaw[] = [
  {
    path: "/board/all",
    name: "board-all",
    meta: {
      label: "全部无限画板",
      auth: false,
      layout: "home",
      useTopbar: true
    },
    component: () => import("@/views/workspace/board/list/index.vue")
  },
  {
    path: "/board/new",
    name: "board-new",
    meta: {
      label: "新建无限画板",
      auth: true,
      layout: "blank",
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/workspace/board/new/index.vue")
  },
  {
    path: "/board/template-workshop/create",
    name: "template-workshop-create",
    meta: {
      label: "创建自由画布模板",
      auth: true,
      layout: "simple",
      useTopbar: true
    },
    component: () => import("@/views/workspace/board/template-workshop/index.vue")
  },
  {
    path: "/board/:boardId",
    name: "board",
    meta: {
      label: "编辑无限画板",
      auth: true,
      layout: "blank",
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/workspace/board/detail/index.vue")
  },
  {
    path: "/board/share/:boardId",
    name: "board-share",
    meta: {
      label: "分享画板",
      auth: false,
      layout: "blank",
      useTopbar: false,
      layoutHidden: true
    },
    component: () => import("@/views/workspace/board/share/index.vue")
  }
];

export default canvasModulesRoutes;
